import { render, staticRenderFns } from "./AlertPopUp.vue?vue&type=template&id=bc9e5742"
import script from "./AlertPopUp.vue?vue&type=script&lang=ts"
export * from "./AlertPopUp.vue?vue&type=script&lang=ts"
import style0 from "./AlertPopUp.vue?vue&type=style&index=0&id=bc9e5742&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports